import store from '@/store';
import {
	Contract,
	BigNumber,
	ethers,
	BrowserProvider
} from 'ethers'
import poolAbi from '@/contracts/pool.json';
import storageAbi from '@/contracts/storage.json';
import Token from '@/handlers/token';
import {
	formatNumber,
	getRandomInt,
	toUint256Hex
} from "@/utils/index.js"
import $envConfig from '@/common/config.js';
class Pool {
	constructor(address = '', provider = null, signer = null, tokenAddress) {
		this.internalAddress = address; // TODO .toLowerCase();
		this.provider = provider;
		this.signer = signer;
		this.tokenAddress = tokenAddress;
		if (!this.address.match(/0x[a-fA-F0-9]{40}/)) return new Error('Missing address');
		this.instance = new Contract(address, poolAbi, signer);

		this.appTokenInstance = new Token($envConfig.VUE_APP_TOKEN, signer);
		this.usdtTokenInstance = new Token($envConfig.VUE_USDT_TOKEN, signer);

		this.storageInstance = new Contract($envConfig.VUE_STORAGE_CONTRACT, storageAbi, signer);
		this.getBaseFee();

		// let random = getRandomInt(100, 900);
		// random = random / Math.pow(10, 9);
		// console.log(Number(random).toFixed(9))
		// this.instance = this.instance.bind(this);
	}

	get address() {
		return this.internalAddress;
	}

	getOwner = () => {
		return new Promise((resolve, reject) => {
			this.instance.owner()
				.then(resolve)
				.catch(reject);
		});
	}

	getAIPTokenBalance = ()=> {
		return new Promise((resolve, reject) => {
			this.appTokenInstance.getBalanceOf(this.address).then((balance) => Number(balance))
				.then(resolve)
				.catch(reject);
		});
	}

	getUSDTTokenBalance = ()=> {
		return new Promise((resolve, reject) => {
			this.usdtTokenInstance.getBalanceOf(this.address).then((balance) => Number(balance))
				.then((balance) => Number(balance))
				.then(resolve)
				.catch(reject);
		});
	}

	getBaseFee = async () => {
		let baseFee = await this.getCheckInCost();
		this.baseFee = Number(baseFee) / Math.pow(10, 18);
	}

	getRealFee() {
		let random = getRandomInt(100, 900);
		// random = random/Math.pow(10,9);
		let fee = Number(this.baseFee + random / Math.pow(10, 9)).toFixed(9);
		return ethers.parseEther(fee)
	}

	getPoints = (from = '') => {
		return new Promise((resolve, reject) => {
			this.instance.getPoints(from)
				.then((points) => Number(points))
				.then(resolve)
				.catch(reject);
		});
	}

	getUplines = (from = '') => {
		return new Promise((resolve, reject) => {
			this.instance.getUplines(from)
				.then(resolve)
				.catch(reject);
		});
	}

	getUsers = (from = '')=> {
		return new Promise((resolve, reject) => {
			this.storageInstance.getUser(from)
				.then(resolve)
				.catch(reject);
		});
	}

	isRegistered = (from = '') => {
		return new Promise((resolve, reject) => {
			this.storageInstance.isRegistered(from)
				.then(resolve)
				.catch(reject);
		});
	}

	getGlobalData = () => {
		return new Promise((resolve, reject) => {
			this.storageInstance.getGlobalStats()
				.then(resolve)
				.catch(reject);
		});
	}

	getRegisterCount = () => {
		return new Promise((resolve, reject) => {
			this.storageInstance.registeredCount()
				.then((points) => Number(points))
				.then(resolve)
				.catch(reject);
		});
	}

	calcRewards = () => {
		return new Promise((resolve, reject) => {
			this.instance.calcRewards()
				.then(resolve)
				.catch(reject);
		});
	}

	getDownLines = (from = '') => {
		return new Promise((resolve, reject) => {
			this.storageInstance.getDownlines(from)
				.then(resolve)
				.catch(reject);
		});
	}

	getCoolDown = () => {
		return new Promise((resolve, reject) => {
			this.instance.getCooldown()
				.then((cooldown) => Number(cooldown))
				.then(resolve)
				.catch(reject);
		});
	}

	getCheckInCost = () => {
		return new Promise((resolve, reject) => {
			this.instance.checkInCost()
				.then((cost) => Number(cost))
				.then(resolve)
				.catch(reject);
		});
	}

	withdraw(from = '') {
		return new Promise((resolve, reject) => {
			let estimateGas;
			this.instance.withdraw.estimateGas(from).then((gas) => {
				console.log("gas", gas)
				estimateGas = gas;
				return this.instance.withdraw(from, {
					gasLimit: estimateGas
				});
			}).then(resolve).catch(reject);
		});
	}

	withdrawe(from = '') {
		return new Promise((resolve, reject) => {
			let estimateGas;
			this.instance.withdrawe.estimateGas(from).then((gas) => {
				console.log("gas", gas)
				estimateGas = gas;
				return this.instance.withdrawe(from, {
					gasLimit: estimateGas
				});
			}).then(resolve).catch(reject);
		});
	}

	register(refer = '') {
		return new Promise((resolve, reject) => {
			if (!refer) {
				refer = ethers.ZeroAddress;
			}
			let baseFee = this.getRealFee();
			this.instance.register.estimateGas(refer, {
				value: baseFee
			}).then((gas) => {
				console.log(gas);
				return this.instance.register(refer, {
					gasLimit: gas,
					value: baseFee
				})
			}).then(resolve)
				.catch(reject);
		});
	}

	checkIn(from = '') {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async (resolve, reject) => {
			let baseFee = this.getRealFee();
			console.log("baseFee", baseFee);
			this.instance.checkIn.estimateGas({
				value: baseFee
			}).then((gas) => {
				console.log("gas", gas);
				return this.instance.checkIn({
					gasLimit: gas,
					value: baseFee
				})
			}).then(resolve).catch(reject);
		});
	}

	claimReward(from = '') {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async (resolve, reject) => {
			let baseFee = this.getRealFee();
			this.instance.claimRewards.estimateGas({
				value: baseFee
			}).then((gas) => {
				console.log("gas", gas);
				return this.instance.claimRewards({
					gasLimit: gas,
					value: baseFee
				})
			}).then(resolve).catch(reject);
		});
	}

	claimUplineRewards(from = '') {
		// eslint-disable-next-line no-async-promise-executor
		return new Promise(async (resolve, reject) => {
			let baseFee = this.getRealFee();
			this.instance.claimUplineRewards.estimateGas({
				value: baseFee
			}).then((gas) => {
				console.log("gas", gas);
				return this.instance.claimUplineRewards({
					gasLimit: gas,
					value: baseFee
				})
			}).then(resolve).catch(reject);
		});
	}

}

export default Pool;